import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL;

async function loadConfig() {
  try {
    const response = await fetch("/config.json");
    const config = await response.json();
    BASE_URL = config.API_URL || BASE_URL;
  } catch (error) {
    console.error("Failed to load config.json. Using default .env API URL", error);
  }
}

loadConfig().then(() => {});

export async function changeTicketStatus(id: string, status: "pending" | "started" | "done") {
  try {
    const response = await authService.apiCall(`${BASE_URL}/ticket-status`, {
      method: "POST",
   
      body: JSON.stringify({ ticketId: id, status: status }),
    });
    const result = await response.json();
   // console.log("Ticket status changed successfully:", result);
    return result;
  } catch (error) {
    console.error("Error changing ticket status:", error);
    throw new Error("Error changing ticket status");
  }
}


export async function historyTicketStatus(id:string) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/ticket-status/${id}`, {
      method: "GET",
      
    
    });
    if (!response.ok) {
      throw new Error('Failed to get tickets');
    }

    const result = await response.json();
    //console.log('Tickets fetched successfully:', result);
    return result;
  } catch (error) {
    console.error('Error fetching tickets:', error);
    throw new Error('Error fetching tickets');
  }

}

export async function getTickets(query: string, perPage: number, pageNo: number) {
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/tickets?query=${query}&perPage=${perPage}&pageNo=${pageNo}`,
      { method: 'GET' }
    );
    if (!response.ok) {
      throw new Error('Failed to get tickets');
    }
    const result = await response.json();
    return result;
  } catch (error: any) {
    console.error('Error fetching tickets:', error);
    throw new Error(error?.message || 'Error fetching tickets');
  }
}

export async function addTicketComment(
  userId: string,
  tenantId: string,
  id: string,
  comment: string
) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/tickets-comments`, {
      method: 'POST',
      body: JSON.stringify({ fromId: userId, tenantId, ticketId: id, comment }),
    });
    const result = await response.json();
    return result;
  } catch (error: any) {
    console.error('Error adding ticket comment:', error);
    throw new Error(error?.message || 'Error adding ticket comment');
  }
}
